module.exports = __webpack_public_path__ + "static/media/icon_email.3acdd1b7.svg";